export default __webpack_public_path__ + "static/pops-map-as-044e555e34a67dd61e0712c9af0ecd0d.svg";